import * as React from "react";
import { SVGProps } from "react";
export function UserCheckValidateIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={18}
      height={18}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#user-check-validate_svg__a)"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M6.425 7.071a3.214 3.214 0 1 0 0-6.428 3.214 3.214 0 0 0 0 6.428ZM6.426 16.071H.641v-.697a5.799 5.799 0 0 1 6.047-5.731 5.799 5.799 0 0 1 4.05 1.928M17.355 10.928l-5.143 6.429-2.571-1.928" />
      </g>
      <defs>
        <clipPath id="user-check-validate_svg__a">
          <path fill="#fff" d="M0 0h18v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
